export const OrderOperation = (json: IOrderOperation): IOrderOperationModel => {
	const fromJSON = (orderOperation: IOrderOperation) => {
		const { date, created_at, payment_type, cart_diet, promo_code, ...rest } = orderOperation
		return {
			createdAt: created_at ? new Date(created_at) : null,
			paymentType: payment_type,
			date: date ? new Date(date) : null,
			cartDiet: cart_diet,
			promoCode: promo_code,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderOperationToJSON = (obj: Partial<IOrderOperationModel>): Partial<IOrderOperation> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}
